module.exports = __webpack_public_path__ + "ad1f8fb3671e87f9c971b7fc3488d5f2.pdf";